"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _urijs = _interopRequireDefault(require("urijs"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactSvg = _interopRequireDefault(require("react-svg"));

var _lodash = require("lodash");

var _this = void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: top;\n  width: 90%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var groupIntoPairs = function groupIntoPairs(arr, f) {
  return Object.entries((0, _lodash.groupBy)(arr, f));
};

var getSvgElementById = function getSvgElementById(svgDomNode) {
  var getEfoLayerGroup = function getEfoLayerGroup(svgDomNode) {
    var svgGroups = svgDomNode.getElementsByTagName("g");

    for (var i = 0; i < svgGroups.length; i++) {
      if (svgGroups[i].id === "LAYER_EFO") {
        return svgGroups[i];
      }
    }
  };

  var efoLayerGroup = getEfoLayerGroup(svgDomNode);

  function _getSvgElementById(id) {
    if (efoLayerGroup) {
      for (var i = 0; i < efoLayerGroup.children.length; i++) {
        if (efoLayerGroup.children[i].id === id) {
          if (efoLayerGroup.children[i].attributes["xlink:href"]) {
            return _getSvgElementById(efoLayerGroup.children[i].attributes["xlink:href"].value.substring(1));
          } else {
            return efoLayerGroup.children[i];
          }
        }
      }
    }
  }

  return _getSvgElementById;
};

var paintSvgElement = function paintSvgElement(element, elementMarkup) {
  return element && elementMarkup && Object.assign(element.style, elementMarkup);
};

var registerEvent = function registerEvent(element, eventType, elementMarkup, callback) {
  element && element.addEventListener(eventType, function () {
    paintSvgElement(element, elementMarkup);
    callback();
  });
};

var initialiseSvgElements = function initialiseSvgElements(getSvgElementById, _ref) {
  var idsWithMarkup = _ref.idsWithMarkup,
      onMouseOver = _ref.onMouseOver,
      onMouseOut = _ref.onMouseOut,
      onClick = _ref.onClick;
  //More than one id can correspond to an element - see the svg "use" elements
  groupIntoPairs(idsWithMarkup.map(function (e) {
    return e.id;
  }).filter(function (e, ix, self) {
    return self.indexOf(e) === ix;
  }).map(function (id) {
    return [getSvgElementById(id), id];
  }), "[0].id").forEach(function (a) {
    var element = a[1][0][0];
    var ids = a[1].map(function (t) {
      return t[1];
    }); //Given an element and its ids, we take the first element of the idsWithMarkup array that is one of the ids

    var markupNormalAndUnderFocus = idsWithMarkup.find(function (m) {
      return ids.includes(m.id);
    });
    paintSvgElement(element, markupNormalAndUnderFocus.markupNormal);
    registerEvent(element, "mouseover", markupNormalAndUnderFocus.markupUnderFocus, onMouseOver.bind(_this, ids));
    registerEvent(element, "mouseout", markupNormalAndUnderFocus.markupNormal, onMouseOut.bind(_this, ids));
    registerEvent(element, "click", {}, onClick.bind(_this, ids));
  });
};

var loadSvg = function loadSvg(species, selectedView) {
  return require("./svg/".concat(species).concat(selectedView ? ".".concat(selectedView) : "", ".svg"));
};

var resolve = function resolve(uri, baseUrl) {
  return (0, _urijs["default"])(uri).is("absolute") ? (0, _urijs["default"])(uri) : (0, _urijs["default"])(uri, baseUrl);
};

var AnatomogramSvgWrapperDiv = _styledComponents["default"].div(_templateObject()); // ReactSVG loads the SVG file asynchronously (hence the callback prop). We don’t use componentDidUpdate or
// componentDidMount because they can’t guarantee that the SVG is already loaded when they’re run.


var AnatomogramSvg = function AnatomogramSvg(props) {
  return _react["default"].createElement(AnatomogramSvgWrapperDiv, null, _react["default"].createElement(_reactSvg["default"], {
    onInjected: function onInjected(error, svgDomNode) {
      if (error) {
        console.log("ReactSVG Error: ".concat(error));
      } else {
        initialiseSvgElements(getSvgElementById(svgDomNode), props);
      }

      props.onInjected(error, svgDomNode);
    },
    src: resolve(loadSvg(props.species, props.selectedView), props.atlasUrl).toString(),
    svgStyle: {
      width: "100%",
      height: "auto",
      paddingLeft: props.selectedView ? "10px" : ""
    }
  }));
};

AnatomogramSvg.propTypes = {
  atlasUrl: _propTypes["default"].string.isRequired,
  species: _propTypes["default"].string.isRequired,
  selectedView: _propTypes["default"].string,
  idsWithMarkup: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired,
    markupNormal: _propTypes["default"].object.isRequired,
    markupUnderFocus: _propTypes["default"].object.isRequired
  })).isRequired,
  onMouseOver: _propTypes["default"].func.isRequired,
  onMouseOut: _propTypes["default"].func.isRequired,
  onClick: _propTypes["default"].func.isRequired,
  onInjected: _propTypes["default"].func.isRequired
};
AnatomogramSvg.defaultProps = {
  onInjected: function onInjected(error, svgDomNode) {}
};
var _default = AnatomogramSvg;
exports["default"] = _default;